import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    buildRowsCountCompleted: (count, total) => `Вставка ${count} из ${total} ${buildCorrectGrammarText(total, [
        "строки",
        "строк",
        "строк"
    ])}...`,
    PREPARING_IMAGES: "Подготовка изображений...",
    buildCreatingTable: (colsCount, rowsCount) => `Создание таблицы из ${colsCount} ${buildCorrectGrammarText(colsCount, [
        "столбца",
        "столбцов",
        "столбцов"
    ])} и ${rowsCount} ${buildCorrectGrammarText(rowsCount, ["строки", "строк", "строк"])}...`,
    PROCESS_COMPLETION: "Завершение..."
};
